import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NumpadModule } from 'packages/sports/web/app/src/numpad/numpad.module';

import { IncrementalStakesContainerComponent } from './components/incremental-stakes-container.component';
import { NumpadHostContainerComponent } from './components/numpad-host-container.component';

@NgModule({
    imports: [CommonModule, NumpadModule],
    declarations: [NumpadHostContainerComponent, IncrementalStakesContainerComponent],
    exports: [NumpadHostContainerComponent, IncrementalStakesContainerComponent],
})
export default class NumpadContainerModule {}
